import React, { useState } from 'react'
import { FaThumbsUp, FaComment, FaEllipsisV, FaRegThumbsUp, FaSave, FaTrash, FaFlag, FaPen, FaShare, FaTimes, FaMinusCircle, FaEnvelope, FaMarker, FaEllipsisH } from 'react-icons/fa'
import officeImg from "../../assets/office.png"
import UserImage from "../../assets/user.png"
import moment from 'moment'
import { Link, useNavigate } from 'react-router-dom'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import Linkify from 'linkify-react'

const PostAd = ({ ad }) => {
    const [profileInfo, setProfileInfo] = useState(false)
    const [postInfo, setPostInfo] = useState(false)
    const [liked, setLiked] = useState(false)
    const [likesCount, setLikesCount] = useState(ad.postAd.likesCount)

    // console.log("postad:", ad)

    const navigate = useNavigate()

    const imageFiles = ad?.postAd.files?.filter(f => f.type === "image") || [];
    const [focusedImg, setFocusedImg] = useState(imageFiles[0]?.url || null);


    const likePost = async (postId) => {
        const previousLiked = liked;

        // Optimistic update
        setLiked(!previousLiked);
        setLikesCount((prev) => prev + (previousLiked ? -1 : 1));

        try {
            const response = await api.patch(
                `/${ad.organization.name}/posts/${postId}/likes`
            );

            const serverLiked = response?.data?.liked;

            // Sync with server truth
            if (serverLiked !== !previousLiked) {
                setLiked(serverLiked);
                setLikesCount((prev) => prev + (serverLiked ? 1 : -1));
            }

        } catch (error) {
            // Revert on failure
            setLiked(previousLiked);
            setLikesCount((prev) => prev + (previousLiked ? 1 : -1));

            console.error("Failed to like post:", error);
            toast.error("Failed to update like.");
        }
    };

    const tooglePostInfo = () => {
        setProfileInfo(false)
        setPostInfo(!postInfo)
    }
    const toogleProfileInfo = () => {
        setProfileInfo(!profileInfo)
        setPostInfo(false)
    }

    const renderImages = () => (
        <>
            <div className="focused-image">
                <img src={focusedImg} alt="onnize" />
            </div>

            {imageFiles.length > 1 && (
                <div className="image-selector">
                    {imageFiles.map((file, i) => (
                        <div
                            key={i}
                            className="image-selector-wrapper"
                            onClick={() => setFocusedImg(file.url)}
                        >
                            <img src={file.url} alt={file.name} />
                        </div>
                    ))}
                </div>
            )}
        </>
    );

    const renderVideo = (file) => (
        <div className="video-container">
            <video controls>
                <source src={file.url} type={file.mimeType} />
            </video>
        </div>
    );

    const renderDocuments = () => (
        <div className="document-container">
            {ad.postAd.files.map((file, i) => {
                const ext = file.name.split(".").pop().toLowerCase();

                if (ext === "pdf") {
                    return (
                        <div key={i} className="document-preview">
                            <iframe src={file.url} title={file.name} loading="lazy" />
                            <a
                                href={file.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="doc-action"
                            >
                                Open PDF
                            </a>
                        </div>
                    );
                }

                return (
                    <div key={i} className="document-download">
                        <span className="doc-name">{file.name}</span>
                        <a
                            href={file.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="doc-action"
                        >
                            Download
                        </a>
                    </div>
                );
            })}
        </div>
    );

    const renderFiles = () => {
        if (!ad.postAd.files?.length) return null;

        switch (ad.postAd.files[0].type) {
            case "image":
                return renderImages();
            case "video":
                return renderVideo(ad.postAd.files[0]);
            case "document":
                return renderDocuments();
            default:
                return null;
        }
    };

    const handleBookmark = async (id, type) => {
        setPostInfo(false)
        try {
            const response = await api.post('/feeds/bookmarks', {
                post: id,
                type: type
            });


            if (response.data.success) {
                alert("Bookmarked!");
            } else {
                alert(response.data.message);
            }

        } catch (error) {
            alert("Something went wrong. Please try again.");
        } finally {
            // Optional: End loading state
        }
    };

    const handelFollow = async (id) => {
        setProfileInfo(false)
        try {
            const response = await api.post(`/${ad.organization.name}/follow`, {
                orgId: ad.organization._id
            });


            if (response.data.success) {
                alert("Followed!");
            } else {
                alert(response.data.message);
            }

        } catch (error) {
            alert("Something went wrong. Please try again.");
        } finally {
            // Optional: End loading state
        }
    }
    const handleReport = async (id, type) => {
        setPostInfo(false)
        try {
            const response = await api.post('/feeds/report', {
                post: id,
                type
            });
            if (response.data.success) {
                toast.success("post reported!");
            } else {
                toast(response.data.message);
            }

        } catch (error) {
            alert(error.response.data.message);
        } finally {
            // Optional: End loading state
        }
    }

    return (
        <div className='post'>
            <div className='org-post'>
                <div className="org-post-header">
                    <div className="org-post-org-info">
                        <div className="profile-details"  onClick={() => navigate(`/${ad.organization.name}`)}>
                            <img
                                src={
                                    ad.organization?.logo
                                        ? ad.organization.logo.url
                                        : officeImg
                                } alt="user profile"
                                className="ad-profile-img"
                            />
                            <div className="post-data-details">
                                <p
                                    className="post-profile-name">{ad?.organization?.name}
                                </p>
                                <div className="post-dates">
                                    <p className='post-label'>{ad.postLabel}</p>
                                </div>
                            </div>
                            <p className='promoted-label'>promoted</p>
                        </div>
                        <div className=""
                            onClick={toogleProfileInfo}
                        >
                            <FaEllipsisV />
                        </div>
                    </div>
                </div>
                <div className={profileInfo ? "profile-info" : "closed-info"}>
                    <div className="post-button-wrapper">
                        <FaMarker />
                        <button className="post-info-btn" onClick={() => handelFollow(ad.organization._id)}>Follow</button>
                    </div>
                    <FaTimes onClick={() => setProfileInfo(false)} />
                </div>
                <div className={postInfo ? "post-info" : "closed-info"}>
                    <FaTimes onClick={() => setPostInfo(false)} />
                    <div className="post-button-wrapper">
                        <FaSave />
                        <button className="post-info-btn" onClick={() => handleBookmark(ad._id, "organization")}>Bookmark</button>
                    </div>
                    <div className="post-button-wrapper">
                        <FaShare />
                        <button className="post-info-btn">Share to</button>
                    </div>
                    <div className="share-options">
                        <p className="share-option">My Profile</p>
                        <p className="share-option">Organization</p>
                        <p className="share-option">see more...</p>
                    </div>
                    <div className="post-button-wrapper">
                        <FaFlag />
                        <button className="post-info-btn" onClick={() => handleReport(ad._id, "organization")}>Report</button>
                    </div>
                </div>
                <div className="post-body">
                    {ad.postAd.postText &&
                            <div className="text" onClick={() => navigate(`/${ad.organization.name}/posts/${ad._id}`, { state: { post: ad } })}
                            >
                                <p>{ad.postAd.postText.substring(0, 100)}</p>
                            </div>
                
                    }

                    {ad.postAd.files?.length > 0 &&
                        <div className="postcard-images">
                            {renderFiles()}
                        </div>
                    }
                </div>
                <div className="post-footer">
                    <div className="post-footer-icon"
                        onClick={() => likePost(ad.postAd._id)}
                    >
                        {liked ? <FaThumbsUp /> : <FaRegThumbsUp />}
                        <p>{likesCount}</p>
                    </div>
                    <div className="post-footer-icon"
                        onClick={() => navigate(`/${ad.organization.name}/posts/${ad.post._id}`, { state: { post: ad.post } })}
                    >
                        <FaComment />
                        <p>{ad.postAd.commentsCount}</p>
                    </div>
                    <div className="post-footer-icon"
                        onClick={tooglePostInfo}
                    >
                        <FaEllipsisH />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PostAd